import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {PrimeNGModule} from '../../core';
import {ProfileRoutingModule} from './profile-routing.module';
import {ProfileService} from '../../core/services/profile.service';
import {ProfileDetailsPage} from './pages/profile-details/profile-details.page';
import {SharedModule} from '../../shared/share.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {UserModule} from '../user/user.module';

@NgModule({
    imports: [
        CommonModule, PrimeNGModule, ProfileRoutingModule, SharedModule, FormsModule, ReactiveFormsModule, UserModule
    ],
  exports: [RouterModule],
  declarations: [ProfileDetailsPage],
  providers: [ProfileService]
})
export class ProfileModule {
}
